import React from 'react';

export function InstagramAuth() {
    const handleLogin = () => {
        const authUrl = `https://api.instagram.com/oauth/authorize?client_id=${process.env.REACT_APP_INSTAGRAM_APPID}&redirect_uri=${encodeURIComponent(process.env.REACT_APP_INSTAGRAM_URL_REDIRECT)}&scope=instagram_business_basic%2Cinstagram_business_manage_messages%2Cinstagram_business_manage_comments%2Cinstagram_business_content_publish&response_type=code`;
        const width = 800;
        const height = 600;
    
        // Calcula a posição central
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;
    
        const windowFeatures = `width=${width},height=${height},top=${top},left=${left},scrollbars=yes`;
    
        window.open(authUrl, "_blank",windowFeatures);
    };

    return (
            <button type="button" className="button-instagram" onClick={e => handleLogin()}>
                <img src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png" alt="Instagram" />
                Conectar ao Instagram
                {/* <InstagramAuth /> */}
            </button>

    );
}